import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface VulnerabilityFiltersProps {
  timeRange: string;
  onTimeRangeChange: (value: string) => void;
  software: string;
  onSoftwareChange: (value: string) => void;
  severity: string;
  onSeverityChange: (value: string) => void;
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export function VulnerabilityFilters({
  timeRange,
  onTimeRangeChange,
  software,
  onSoftwareChange,
  severity,
  onSeverityChange,
  searchQuery,
  onSearchChange,
}: VulnerabilityFiltersProps) {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6">
      <Select value={timeRange} onValueChange={onTimeRangeChange}>
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Time range" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All time</SelectItem>
          <SelectItem value="24h">Last 24 hours</SelectItem>
          <SelectItem value="7d">Last 7 days</SelectItem>
          <SelectItem value="30d">Last 30 days</SelectItem>
          <SelectItem value="90d">Last 90 days</SelectItem>
        </SelectContent>
      </Select>

      <Select value={software} onValueChange={onSoftwareChange}>
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Software" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All software</SelectItem>
          <SelectItem value="macOS">macOS</SelectItem>
          <SelectItem value="iOS">iOS</SelectItem>
          <SelectItem value="iPadOS">iPadOS</SelectItem>
          <SelectItem value="Safari">Safari</SelectItem>
          <SelectItem value="WebKit">WebKit</SelectItem>
          <SelectItem value="watchOS">watchOS</SelectItem>
          <SelectItem value="tvOS">tvOS</SelectItem>
          <SelectItem value="visionOS">visionOS</SelectItem>
        </SelectContent>
      </Select>

      <Select value={severity} onValueChange={onSeverityChange}>
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Severity" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All severities</SelectItem>
          <SelectItem value="CRITICAL">Critical</SelectItem>
          <SelectItem value="HIGH">High</SelectItem>
          <SelectItem value="MEDIUM">Medium</SelectItem>
          <SelectItem value="LOW">Low</SelectItem>
        </SelectContent>
      </Select>

      <div className="relative flex-1">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          type="search"
          placeholder="Search CVEs..."
          className="pl-8"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
}
